import angular from 'angular';

export default angular.module('app.services.hideThatProductModule', [])
  .service('hideThatProduct', () => {
    return {
      hideAcquisitionProduct: (user) => {
        return user.hasRole(['APP_DEVELOPER', 'GD_ACCOUNT_MANAGER', 'AGENCY']);
      },
      hideAnalytics: (user) => {
        return user.hasRole(['APP_DEVELOPER', 'AGENCY']);
      }
    };
  });



/** WEBPACK FOOTER **
 ** ./src/services/hideThatProduct.js
 **/